import { render, staticRenderFns } from "./baseBoxWithIf.vue?vue&type=template&id=6bc2d882&scoped=true&"
import script from "./baseBoxWithIf.vue?vue&type=script&lang=js&"
export * from "./baseBoxWithIf.vue?vue&type=script&lang=js&"
import style0 from "./baseBoxWithIf.vue?vue&type=style&index=0&id=6bc2d882&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2d882",
  null
  
)

export default component.exports